import api from '../../../api/clinique/_prescriptions'

const state = () => ({
    prescriptions_en_cours: []
})

// getters
const getters = {
    prescriptions_en_cours: (state) => {
        return state.prescriptions_en_cours
    }

}

// mutations
const mutations = {
    SET_PRESCRIPTIONS_EN_COURS(state, prescription) {
        state.prescriptions_en_cours = prescription;
    }
}

// actions
const actions = {
    /**
     * Récupère les soins & hospitalisation  en cours
     * @param {*} param0 
     * @returns 
     */
    getPrescriptionsEnCours({ commit }) {
        return new Promise((resolve) => {
            api.getPrescriptionsEnCours().then(
                response => {
                    commit('SET_PRESCRIPTIONS_EN_COURS', response)
                    resolve(response)
                }
            )
        })
    }


}

export default {
    state,
    getters,
    mutations,
    actions
}